import { MapPin, ShieldCheck } from "lucide-react";

export default function BBAPBook() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center">
      <span className="inline-block px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide bg-[#4FD1C5]/15 text-[#1E3A6E] border border-[#4FD1C5]/40 mb-6">
        Coming Soon
      </span>

      <div className="rounded-sm overflow-hidden border border-zinc-200 mb-8">
        <img
          src="https://images.unsplash.com/photo-1611432579699-484f7990b127?crop=entropy&cs=srgb&fm=jpg&q=85"
          alt="A small business owner who treats her customers with dignity"
          className="w-full h-64 object-cover"
        />
      </div>

      <div className="inline-flex h-14 w-14 rounded-full bg-[#EAF3F7] border border-zinc-200 items-center justify-center mb-6">
        <MapPin className="h-6 w-6 text-[#1E3A6E]" />
      </div>
      <h1 className="font-display font-extrabold uppercase text-3xl md:text-5xl text-zinc-950 tracking-tight mb-5">
        The BBAP Book
      </h1>
      <p className="text-zinc-600 leading-relaxed max-w-xl mx-auto mb-6">
        A modern take on the historical Green Book concept — a directory of businesses and places that treat
        people with dignity. Not based on who owns them, but on how people are actually treated. It'll help
        you find where to spend money safely, and recognize the businesses already getting it right.
      </p>
      <div className="flex items-center justify-center gap-2 text-zinc-500 text-sm mb-6">
        <ShieldCheck className="h-4 w-4 text-[#1E3A6E]" />
        Powered by the same documentation data as our voting feed and incident reports.
      </div>
      <p className="text-zinc-500 text-sm max-w-xl mx-auto">
        Businesses that consistently treat people with dignity will also be able to display a BBAP Trust Mark
        decal — a visible signal to customers, and their own opt-out from any blanket boycott.
      </p>
    </div>
  );
}
